import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Divider, Form, Input, Tag } from "antd";
import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import { deleteRequest, putRequest } from "../../../api/http";
import userServiceApi from "../../../api/userServiceApi";
import { useTab } from "../../../custom-hooks/useTab";
import { useStore } from "../../../store";
import { setProductGroups } from "../../../store/actions";

export default function ProductsConfigurations({ micrositeId, tabConfigId }) {


  const [form] = Form.useForm();
  const inputRef = useRef(null);

  const { product_groups, dispatch } = useStore();
  const { getOptions } = useTab();

  const [newProducts, setNewProducts] = useState([]);
  const [editID, setEditID] = useState();

  const handleAdd = ({ itemField }) => {
    if (itemField.trim().length) {
      setNewProducts([...newProducts, itemField]);
      inputRef.current.value = "";
      inputRef.current.focus();
      form.resetFields();
    }
  };

  const handleRemove = (tagToRemove) => {
    setNewProducts(newProducts.filter((tag) => tag !== tagToRemove));
  };

  const handleSave = async () => {
    const moddedArray = newProducts.map((item) => {
      return {
        title: item,
      };
    });
    try {
      const res = await putRequest(
        userServiceApi.saveTeamsCoursesProducts(micrositeId, tabConfigId),
        moddedArray
      );
      if (res) {
        toast.success("New products added");
        setNewProducts([]);
        dispatch(setProductGroups(res));
      }
    } catch (error) { }
  };

  const handleDelete = async (product) => {
    try {
      const res = await deleteRequest(
        userServiceApi.deleteTeamsCoursesProduct(product.id)
      );
      if (res) {
        toast.success("Product deleted successfully");
        getOptions(micrositeId, "PRODUCT", localStorage.getItem("selectedTabId"));
      }
    } catch (error) { }
  };

  const handleEdit = async (value) => {
    let editArray = [
      {
        title: value.productname,
        id: editID,
      },
    ];

    try {
      const res = await putRequest(
        userServiceApi.saveTeamsCoursesProducts(micrositeId, tabConfigId),
        editArray
      );
      if (res) {
        setEditID();
        toast.success("Product edited successfully");
        dispatch(setProductGroups(res));
      }
    } catch (error) {
      // toast.error("Something went wrong, try again later.")
    }
  };

  return (
    <div className="tabContent">
      <div className="add-field">
        <Form form={form} className="add-field-form" onFinish={handleAdd}>
          <Form.Item name="itemField"
            rules={[
              {
                required: true,
                message: "Please enter new product group",
              },
            ]}
          >
            <Input
              ref={inputRef}
              className="input-field"
              placeholder="Enter new product group"

            />
          </Form.Item>
          <Form.Item>
            <Button className="greenBtn add-btn" htmlType="submit">
              Add
            </Button>
          </Form.Item>
        </Form>
      </div>
      {newProducts.length > 0 && (
        <>
          <div className="new-items">
            {newProducts.map((newItem, index) => (
              <div className="tag" key={newItem}>
                <Tag
                  className="tags-component"
                  closable={true}
                  onClose={() => handleRemove(newItem)}
                >
                  {newItem}
                </Tag>
              </div>
            ))}
          </div>
          <div className="btn-container">
            <Button className="greenBtn SaveBtn" onClick={handleSave}>
              Save
            </Button>
          </div>
        </>
      )}
      <Divider />
      <div className="display fgdf">
        {product_groups.map((product) => (
          <div className="product-item">
            {product.id === editID ? (
              <>
                <Form
                  onFinish={handleEdit}
                  className="item-edit-form"
                  initialValues={{
                    productname: product.title,
                  }}
                >
                  <Form.Item name="productname">
                    <Input className="edit-input" />
                  </Form.Item>
                  <>
                    <Form.Item>
                      <Button
                        style={{ marginRight: "5px" }}
                        className="greenBtn SaveBtn"
                        htmlType="submit"
                      >
                        Save
                      </Button>
                    </Form.Item>
                    <Form.Item>
                      <Button className="SaveBtn" onClick={() => setEditID()}>
                        Cancel
                      </Button>
                    </Form.Item>
                  </>
                </Form>
              </>
            ) : (
              <>
                <h3>{product.title}</h3>
                <div className="op-btns">
                  <div className="remove-btns">
                    <EditOutlined onClick={() => setEditID(product.id)} />
                  </div>
                  <div className="remove-btns">
                    <DeleteOutlined onClick={() => handleDelete(product)} />
                  </div>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
